import React from "react";

// Mini spinner ↑↓ care apare pe fiecare celulă regie/proiect
// Permite ajustare ±1 pe zi pentru min_people (override per zi)
// Vizibilitate: 40% normal, 100% pe hover pe celulă — descoperibile dar discrete
export function DayMinSpinner({ testId, isOverride, minVal, onUp, onDown }) {
  const stop = (e) => e.stopPropagation();
  return (
    <div
      className={`absolute right-0 top-0 bottom-0 flex flex-col opacity-40 group-hover/cell:opacity-100 transition-opacity z-10 ${isOverride ? "ring-1 ring-violet-400" : ""}`}
      onClick={stop}
      data-testid={testId}
    >
      <button
        type="button"
        onClick={(e) => { stop(e); onUp(); }}
        className="flex-1 px-1 text-[10px] leading-none bg-white/95 hover:bg-emerald-100 border border-zinc-200 text-emerald-700 font-bold"
        title={`+1 (zi)${isOverride ? " · override activ" : ""}`}
        data-testid={`${testId}-up`}
      >▲</button>
      <button
        type="button"
        onClick={(e) => { stop(e); onDown(); }}
        className="flex-1 px-1 text-[10px] leading-none bg-white/95 hover:bg-red-100 border border-zinc-200 border-t-0 text-red-700 font-bold"
        title={`-1 (zi)${isOverride ? " · override activ" : ""}`}
        data-testid={`${testId}-down`}
      >▼</button>
    </div>
  );
}
